package com.macrofocus.trenddisplay.timeseriesplot

import com.macrofocus.trenddisplay.timeseriesplot.TimeSeriesPlotConfiguration.MarkerType
import org.mkui.geom.GeneralPath
import org.mkui.geom.Path2D
import org.mkui.geom.Rectangle2D
import org.mkui.geom.Shape
import org.mkui.graphics.IGraphics
import org.mkui.transform.TwoDScreenTransform
import org.molap.series.TimeSeries

class GeneralPathTimeSeriesRenderer<TimeMode> : TimeSeriesPlotRenderer {
    override fun getShape(
        timeSeries: TimeSeries<Int, *>?,
        screenTransform: TwoDScreenTransform,
        mode: TimeSeries.TimeMode,
        configuration: TimeSeriesPlotConfiguration
    ): Pair<Path2D.Double,Path2D.Double> {
        val markerPath: GeneralPath = GeneralPath()
        val linePath: GeneralPath = GeneralPath()

        val isNumerical = true
        if (isNumerical) {
            if (timeSeries != null) {
                var previous: RangePoint? = null

                for (i in timeSeries.keys()!!) {
                    val x: Int = screenTransform.xWorldToScreen(timeSeries.getTime(mode, i).toDouble())
                    val yValue: Any? = timeSeries.get(i)
                    if (yValue != null) {
                        val y: Int = screenTransform.yWorldToScreen((yValue as Number).toDouble())

                        if (previous != null) {
                            if (x != previous.x) {
                                if (previous.yMin != previous.yMax) {
                                    if (configuration.getLineType() != TimeSeriesPlotConfiguration.LineType.None) {
                                        linePath.lineTo(previous.x.toDouble(), previous.yMin.toDouble())
                                        linePath.lineTo(previous.x.toDouble(), previous.yMax.toDouble())
                                        linePath.lineTo(previous.x.toDouble(), previous.y.toDouble())
                                    }
                                }
                                if (configuration.getLineType() != TimeSeriesPlotConfiguration.LineType.None) {
                                    if (configuration.getLineType() == TimeSeriesPlotConfiguration.LineType.Step) {
                                        linePath.lineTo(x.toDouble(), previous.y.toDouble())
                                    }
                                    linePath.lineTo(x.toDouble(), y.toDouble())
                                }
                            }
                            previous.setValue(x, y)
                        } else {
                            previous = RangePoint()
                            previous!!.setValue(x, y)
                            linePath.moveTo(x.toDouble(), y.toDouble())
                            linePath.lineTo(x.toDouble(), y.toDouble())
                        }

                        if (configuration.getMarkerType() != MarkerType.None) {
                            val size = configuration.getMarkerSize().toDouble()
                            val halfSize = size / 2.0
                            val shape: Shape = Rectangle2D.Double(x - halfSize, y - halfSize, size, size)
                            markerPath.append(shape.getPathIterator(), false)
                        }
                    } else {
                        previous = null
                    }
                }
            }
        } else {
//            final TimeSeriesVariable timeSeriesVariable = (TimeSeriesVariable) variable;
//            final TimeSeries timeSeries = (TimeSeries) timeSeriesVariable.getValue(dataset, plot.getSubject());

            if (timeSeries != null) {
                if (configuration.getMarkerType() != MarkerType.None || configuration.getDisplayValue()) {
//                    val textY: Int = g2.getFontMetrics()!!.getAscent()
                    for (i in 0..<timeSeries.size()) {
//                        final int x = plot.worldToScreenX(timeSeries.getTime(i));
                        val value: Any? = timeSeries.get(i)

                        if (value != null) {
                            when (configuration.getMarkerType()) {
                                MarkerType.VerticalLine -> {}
                                MarkerType.Point -> {
                                    val size = configuration.getMarkerSize()
                                    val halfSize = size / 2.0f
                                }
                                MarkerType.None -> {}
                            }
                            if (configuration.getDisplayValue()) {
                                when (configuration.getMarkerType()) {
                                    MarkerType.None, MarkerType.VerticalLine -> {}
                                    MarkerType.Point -> {}
                                }
                            }
                        }
                    }
                }
            }
        }

        return Pair(markerPath, linePath)
    }

    override fun draw(
        timeSeries: TimeSeries<Int, *>?,
        screenTransform: TwoDScreenTransform,
        g2: IGraphics,
        mode: TimeSeries.TimeMode,
        configuration: TimeSeriesPlotConfiguration,
        probed: Boolean,
        selected: Boolean
    ) {
        val (markerPath, linePath) = getShape(timeSeries, screenTransform, mode, configuration)
        g2.setColor(configuration.getLineColor())
        g2.setLineWidth(configuration.getLineWidth().toDouble())
        g2.pickDraw(linePath, null, null, null)

        g2.setColor(configuration.getMarkerColor())
        g2.pickDraw(markerPath, null, null, null)

//        g2.setColor(oldColour);
//        g2.setStroke(oldStroke);
//        g2.setFont(oldFont);
    }

    private inner class RangePoint {
        var x: Int = 0
        var y: Int = 0
        var yMin: Int = 0
        var yMax: Int = 0

        fun setValue(x: Int, y: Int) {
            if (this.x == x) {
                if (y < yMin) {
                    yMin = y
                }
                if (y > yMax) {
                    yMax = y
                }
                this.y = y
            } else {
                this.x = x
                this.y = y
                this.yMin = y
                this.yMax = y
            }
        }
    }
}
